import React, { Component } from 'react';
import './TVGlitch.css';

class TVGlitch extends Component {

  /*constructor (props) {
    super(props);
  }*/
  
  render() {
    return (
        <div
          className="tv-glitch"
          />
    )
  }

}

export default TVGlitch;


// WEBPACK FOOTER //
// ./src/components/TVGlitch/TVGlitch.component.js